import {
  RESPONSIVE_BREAKPOINTS,
  minWidthQuery,
} from 'constants/Global/ResponsiveLayout.const';
import { useMediaQuery } from 'hooks/useMediaQuery';

export type ResponsiveLayout = 'phone' | 'tablet' | 'table' | 'desktop';

export function useResponsiveLayout(): ResponsiveLayout {
  const isTabletWidth = useMediaQuery(
    minWidthQuery(RESPONSIVE_BREAKPOINTS.tablet),
  );
  const isTableWidth = useMediaQuery(
    minWidthQuery(RESPONSIVE_BREAKPOINTS.table),
  );
  const isDesktopWidth = useMediaQuery(
    minWidthQuery(RESPONSIVE_BREAKPOINTS.desktop),
  );

  if (isDesktopWidth) return 'desktop';
  if (isTableWidth) return 'table';
  return isTabletWidth ? 'tablet' : 'phone';
}

export const isCardsLayout = (layout: ResponsiveLayout): boolean =>
  layout === 'phone' || layout === 'tablet';
